import React, { useState, useEffect } from "react";
import "./FeatureManager.css";

export default function FeatureManager() {
  const [features, setFeatures] = useState([]);
  const [newFeature, setNewFeature] = useState("");
  const [errorMsg, setErrorMsg] = useState("");



  useEffect(() => {
    fetchFeatures();
  }, []);

  // Fetch all features. Guard against non-array responses (the endpoint
  // returns { success:false, message } on failure) — previously we set
  // whatever came back into state, and features.map(...) then threw so
  // the list rendered empty and no new-added row was visible.
  const fetchFeatures = async () => {
    try {
      const res = await fetch(`${global.API_STRIPEAPI_URL}getAllFeatures`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (Array.isArray(data)) {
        setFeatures(data);
      } else {
        setErrorMsg((data && data.message) || "Failed to load features");
      }
    } catch (err) {
      setErrorMsg(err.message || "Failed to load features");
    }
  };

  // Add new feature. Previously we didn't check the POST response — a 400
  // ("name is required") or 500 (create failed) was swallowed, leaving the
  // list unchanged with no indication of what went wrong. Now we surface
  // the error and only refresh the list on real success.
  const addFeature = async () => {
    setErrorMsg("");
    if (!newFeature.trim()) {
      setErrorMsg("Please enter a feature name");
      return;
    }
    try {
      const res = await fetch(`${global.API_STRIPEAPI_URL}features`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: newFeature.trim(), is_available: true }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.success === false) {
        setErrorMsg(data.message || "Failed to add feature");
        return;
      }
      setNewFeature("");
      await fetchFeatures();
    } catch (err) {
      setErrorMsg(err.message || "Failed to add feature");
    }
  };

  // Toggle availability
  const toggleFeature = async (id, current) => {
    const feature = features.find(f => f.id === id);
    setFeatures((prevFeatures) => {
      const updatedFeatures = prevFeatures.map((f) =>
        f.id === id ? { ...f, is_available: !current } : f
      );
      setFeatures(updatedFeatures);
      return updatedFeatures;
    });
    await fetch(`${global.API_STRIPEAPI_URL}features/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...feature, is_available: !current }),
    });
    
  };

  // Delete feature
  const deleteFeature = async (id) => {
    await fetch(`${global.API_STRIPEAPI_URL}features/${id}`, { method: "DELETE" });
    fetchFeatures();
  };

  return (
    <div className="feature-manager">
      <h2 className="feature-manager-h2">Manage Features</h2>

      <div className="feature-manager-add-feature">
        <input
          type="text"
          placeholder="New feature name"
          value={newFeature}
          onChange={(e) => setNewFeature(e.target.value)}
        />
        <button onClick={addFeature}>Add</button>
      </div>
      {errorMsg && (
        <div className="feature-manager-error" style={{ color: "red", marginTop: 8 }}>
          {errorMsg}
        </div>
      )}

      <ul className="feature-manager-feature-list">
        {features.map((f) => (
          <li key={f.id} className="feature-manager-feature-item">
            <span>{f.name}</span>
            <div className="feature-manager-actions">
              <label className="feature-manager-label">
                <input
                  type="checkbox"
                  checked={f.is_available}
                  onChange={() => toggleFeature(f.id, f.is_available)}
                />
                Available
              </label>
              <button
                onClick={() => deleteFeature(f.id)}
                className="feature-manager-delete-btn"
              >
                X
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}